/**
 * Description: 保存用户信息
 * Author: Wuzhiyi
 * Date: 2018/10/22
 * Time: 14:40
 *
 */
export default {
    /**
     * 向cookie存入用户信息
     * @param user user对象存放基本信息
     */
    setUser(user) {
        this.setCookie(window.global.cookieName, JSON.stringify(user), 1000 * 60 * 60 * 8 - 10000);
    },

    /**
     * 从cookie取出用户信息
     * @return {*}
     */
    getUser() {
        if (this.getCookie(window.global.cookieName)) {
            return JSON.parse(this.getCookie(window.global.cookieName))
        }
        return null
    },

    /**
     * 删除cookie中user对象信息
     * @param user
     */
    removeUser() {
        this.setCookie(window.global.cookieName, '', -1)
    },

    /**
     * 根据cookie中是否有user对象来判断是否登录
     * @return {boolean}
     */
    loginState() {
        if (this.getCookie(window.global.cookieName)) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 向cookie中存入登录设备的状态（ '3':微信，'2':IOS, '1':Android ）
     * @param type
     */
    setType(type) {
        this.setCookie('type', type, 120)
    },

    /**
     * 从cookie取登录设备状态
     * @return {*|string}
     */
    getType() {
        return this.getCookie('type');
    },

    /**
     * 向cookie存入openId
     * @param openId
     */
    setOpenId(openId) {
        this.setCookie('openId', openId, 120)
    },

    /**
     * 从cookie取出openId
     * @return {*|string}
     */
    getOpenId() {
        return this.getCookie('openId')
    },

    /**
     * 存入cookie方法
     * @param c_name cookie字段名
     * @param value 存入的值
     * @param expiredays 存入的时效
     */
    setCookie(c_name, value, expiredays) {
        const time = new Date();
        time.setTime(time.getTime() + expiredays);
        document.cookie = c_name + "=" + escape(value) + ((expiredays === 0) ? "" : ";expires=" + time.toUTCString() + ";path=/")
    },
    /**
     * 刷新cookie
     * @param key
     */
    refreshCookie(key) {
        let value = this.getCookie(key);
        if (value) {
            this.removeCookie(key);
            let exp = 60 * 1000 * 60 * 8 - 10000;
            let time = new Date();
            time.setTime(time.getTime() + exp);
            document.cookie = key + "=" + escape(value) + ((exp === 0) ? "" : ";expires=" + time.toUTCString() + ";path=/")
        }
    },
    /**
     * 异常cookie
     * @param key
     */
    removeCookie(key) {
        this.setCookie(key, '', -1)
    },
    /**
     * 取回cookie方法
     * @param c_name cookie字段名
     * @return {string}
     */
    getCookie(c_name) {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=")
            if (c_start !== -1) {
                c_start = c_start + c_name.length + 1
                let c_end = document.cookie.indexOf(";", c_start)
                if (c_end === -1) c_end = document.cookie.length
                return unescape(document.cookie.substring(c_start, c_end))
            }
        }
        return ""
    }
}
